var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorkflowArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 9",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.783 5.05H.667a.65.65 0 0 1-.475-.192A.65.65 0 0 1 0 4.383q0-.283.192-.475a.65.65 0 0 1 .475-.191h10.116L8.2 1.117a.65.65 0 0 1-.192-.459A.62.62 0 0 1 8.2.183.63.63 0 0 1 8.667 0q.283 0 .466.183l3.734 3.734a.6.6 0 0 1 .141.216.7.7 0 0 1 .042.25.7.7 0 0 1-.042.25.6.6 0 0 1-.141.217L9.133 8.583a.62.62 0 0 1-.458.184.68.68 0 0 1-.475-.184.65.65 0 0 1-.2-.475q0-.274.2-.475z"
})));
export default SvgWorkflowArrow;